/**
 * Default Google Maps configuration options
 *
 * @type {{mapTypeControl: boolean, center: *, fullscreenControl: boolean, streetViewControl: boolean, zoom: number, styles: *[], zoomControl: boolean}}
 */
export const options = {
  zoom: 13,
  center: new google.maps.LatLng(42.688842, 23.327071),
  // mapTypeId: google.maps.MapTypeId.TERRAIN,
  fullscreenControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  zoomControl: true,
  styles: [
    {
      "featureType": "all",
      "stylers": [
        {
          "saturation": 0
        },
        {
          "hue": "#e7ecf0"
        }
      ]
    },
    {
      "featureType": "road",
      "stylers": [
        {
          "saturation": -70
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "stylers": [
        {
          "visibility": "simplified"
        },
        {
          "saturation": -60
        }
      ]
    }
  ]
};

/**
 * Default MarkerClusterer configuration options
 *
 * @type {{ignoreHidden: boolean, styles: *[], clusterClass: string}}
 */
export const clusterOptions = {
  ignoreHidden: true,
  clusterClass: 'cluster-marker',
  // maxZoom: 6,
  styles: [
    {
      height: 32,
      width: 32,
      textSize: 12,
      url: '/assets/images/icons/markerClustering/m1.png'
    },
    {
      height: 36,
      width: 36,
      textSize: 12,
      url: '/assets/images/icons/markerClustering/m2.png'
    },
    {
      height: 40,
      width: 40,
      textSize: 12,
      url: '/assets/images/icons/markerClustering/m3.png'
    },
    {
      height: 40,
      width: 40,
      textSize: 12,
      url: '/assets/images/icons/markerClustering/m4.png'
    },
    {
      height: 48,
      width: 48,
      textSize: 12,
      url: '/assets/images/icons/markerClustering/m5.png'
    }
  ]
};
